import { render, staticRenderFns } from "./ExhibitionGoods.vue?vue&type=template&id=8ed17a16"
import script from "./ExhibitionGoods.vue?vue&type=script&lang=js"
export * from "./ExhibitionGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports